import SelectAbstract from "components/SelectAbstract";

import Input from "components/Input";
import Calendar from "components/Calendar";

import { ReactComponent as CalendarIcon } from 'icons/components/calendar.svg';

import './themes/default.less';
import './index.less';

export default class SelectDateCalendar extends SelectAbstract {

    constructor(props) {
        super(props);
        
        const defaultValue = props.defaultValue ? this._helper.date.create(props.defaultValue) : null;

        this.state = {
            value: defaultValue,
            selected: defaultValue,
        };
    }

    set value(val) {
        const value = this._helper.date.create(val);

        this.inputDate.value = this._helper.date.toStr(value, 'DD MMMM, YYYY');
        this.state.selected = value;
        this.state.value = value;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            const newValue = this._helper.date.create(this.props.defaultValue);
            this.setState({
                value: newValue,
                selected: newValue,
            });
            this.inputDate.value = this._helper.date.toStr(newValue, 'DD MMMM, YYYY');
        }
    }

    get value() {
        return this.state.value;
    }

    getMainStyle() {
        return "selectDateCalendar";
    }

    onChange(date) {
        this.state.selected = date;
        this.inputDate.value = this._helper.date.toStr(date, 'DD MMMM, YYYY');
        this.setOpenedState(false);

        if (this.props.onChange?.apply)
            this.props.onChange(this._helper.date.toStr(date));
    }

    onCalendarFirstMonthChange(date) {
        this.changeState('value', date);
    }

    renderSelector() {
        const { label } = this.props;
        const { value } = this.state;
        return (
            <div ref={el => this.selector = el} className="selectorDate flex flex1 centerV hand" onClick={this.toggleOpenedState.bind(this)}>
                <Input
                    ref={el => this.inputDate = el}
                    itemStyle={"flex1"}
                    placeHolder="client.date"
                    label={label || "client.date"}
                    readonly={true}
                    value={value ? this._helper.date.toStr(value, 'DD MMMM, YYYY') : ""}
                    iconRight={<CalendarIcon />}
                />
            </div>
        );
    }

    renderPopup() {
        const { value, selected } = this.state;
        return (
            <div ref={el => this.popup = el} className="selectPopup flex flex1 centerH pos abs">
                <div className="calendarCont">
                    <Calendar
                        value={value ? value : new Date()}
                        selected={selected ? selected : new Date()}
                        interval={1}
                        pastOff={this.props.pastOff}
                        onChange={this.onChange.bind(this)}
                        onMonthChange={this.onCalendarFirstMonthChange.bind(this)}
                    />
                </div>
            </div>
        );
    }


}
